module.exports = __webpack_public_path__ + "static/media/align-slash.2f46992e.svg";